<template lang="pug">
  main
    section.section.is-large
      .container
        .content.has-text-centered
          h1 {{ `Guardados ${actual} de ${total}`}}&nbsp
            i.fa.fa-spinner.fa-spin(style="font-size:48px")
</template>

<script>
  export default {
    name: 'LoaderInfo',
    props: {
      total: {
        type: Number,
        default: 0,
      },
      actual: {
        type: Number,
        default: 0,
      },
    },
  }
</script>


<style lang="scss" scoped>
  .content {
    padding: 20px;
    min-height: 40vh;
  }
</style>


// WEBPACK FOOTER //
// src/components/shared/LoaderInfo.vue